import React,{Fragment, useState} from 'react'
import { hasPermission } from '../../services/permission'
import { Icon } from 'antd'
import {AppPopover} from 'qcc'
import './index.less'
import api from 'api'
import {appModule} from 'services/module'

export interface AppButtonProps {
	width?: number
	actionCode?: string
	type?:  'default' | 'primary'  | 'dangerous' | 'link' | 'icon'
    action?:  ()=> void
    auditAction ?: () => Promise<boolean>
	iconType?: string
	label?: string
    loading?:boolean
}

const ActionType = {
    default:'default',
    primary:'primary',
    dangerous:'dangerous',
    link:'link',
    icon:'icon'
}

export interface AppButtonItemProps {
	actionCode?: string
    action?: () => void
    auditAction ?: () => Promise<boolean>
	label?: string
}

interface IAppButtonProps extends AppButtonProps{
    items?:AppButtonItemProps[]
}

class AppActionItem extends React.Component<AppButtonItemProps> {
	static defaultProps: AppButtonItemProps = {
	    label: ''
	}
}


export class AppButton extends  React.Component<AppButtonProps>{
    state ={
        loading:this.props.loading || false,
        items:getActionItems(this.props.children) 
    }

    static Item = AppActionItem;

    setLoading = () =>{
        this.setState({loading:true})
    }

    cancelLoading = () =>{
        this.setState({loading:false})
    }


    renderButton = () =>{
        let {loading,items} = this.state;
        const actionType = this.props.type || ActionType.default;
        let IActionProps = {...this.props,loading,items};
        switch (actionType ){
            case ActionType.link:
                return  <AppButtonLink {...IActionProps} />
            case ActionType.icon:
                return <AppButtonIcon {...IActionProps} />
            default:
                return <AppButtonCommon {...IActionProps} />
        }
    }

    render () {
        return this.renderButton();
    }
}

const getActionItems = (children: React.ReactNode) =>{
    let items = [] as AppButtonItemProps[];
    if(children && React.Children.toArray(children)){
        React.Children.toArray(children).map((c:any)=>{
            items.push({...c.props})
        })
    }
    return items;
}

const AppButtonCommon = (props:IAppButtonProps) =>{

    const refButton = React.createRef<HTMLSpanElement>();

    const  handClick = async () =>{
        if(props.loading) return;
        if(props.items.length){
            let width = props.width || 100;
            AppPopover.open(<AppButtonMultList {...props}/>,{width},refButton.current)
            return
        }
        hanldClickEvent(props);
    }

    const renderIcon = () =>{
        let iconType =props.loading? 'loading':(props.iconType||'')
        return iconType === '' ? <Fragment /> : <Icon type={iconType} style={{ marginRight: 6 }} />
    }

    const renderIconDown = () =>{
        return props.items.length>0 ? <Icon type='down' className='app-button-icon-down'/>:<Fragment />;
    }
    
   const renderButton = () =>{
        if (!hasPermission(props.actionCode)) return <Fragment />
        return (
            <span
                className='app-button'
                ref={refButton}
                data-type={props.type || 'default'}
                style={{ minWidth: props.width || 100 }}
                onClick={handClick}
            >
                {renderIcon()}
                {props.label || ''}
                {renderIconDown()}
            </span>
        )
    } 

    return  renderButton();
}


const AppButtonMultList = (props:IAppButtonProps) =>{

    return (<div className='app-button-mult-container'>
        {props.items.map((item:AppButtonItemProps,index)=>{
            return hasPermission(item.actionCode)?
                   <span className='app-button-mult-item' 
                         key={index}
                         data-type = {props.type||''}
                         onClick={()=>{AppPopover.close();item.action && item.action()}}
                   >{item.label||''}
                   </span>
                   :<Fragment />
        })}
    </div>)
}

const AppButtonLink = (props:IAppButtonProps) =>{

    const refButton = React.createRef<HTMLSpanElement>();

    const  handClick = () =>{
        if(props.items.length){
            AppPopover.open(<AppButtonMultList {...props}/>,{width:100},refButton.current)
            return
        }
        // props.action && props.action();
        hanldClickEvent(props);
     }

    const renderIconDown = () =>{
        return props.items.length>0 ? <Icon type='down' className='app-button-link-icon-down'/>:<Fragment />;
    }

    const renderButton = () =>{
        if (!hasPermission(props.actionCode)) return <React.Fragment />
        return (
            <span 
                className='app-button-link' 
                onClick={() => handClick()}
                ref={refButton}
            >
                {props.label || ''}
                {renderIconDown()}
            </span>)
    }

    return renderButton();
}




const AppButtonIcon = (props:IAppButtonProps) =>{

    const  handClick = () =>{
        // props.action && props.action();
        hanldClickEvent(props);
     }

    const renderButton = () =>{
        if (!hasPermission(props.actionCode)) return <React.Fragment />
        return (<Icon 
                className='app-button-icon' 
                onClick={() => handClick()}
                title  = {props.label||''}
                type={props.iconType}
            />)
    }

    return renderButton();
}


const hanldClickEvent = async (props?:any) =>{
    let{action,auditAction,label,actionCode} = props;
    if(action) {
        action();
        return;
    }
    if(auditAction){
        let res = await auditAction();
        if(res) {
            let oprLog = {...appModule.getActiveModuleAudit(),actionCode,actionName:label};
            await api.audit.save(oprLog);
        }
    }
}










// WEBPACK FOOTER //
// ./src/qcc/AppButton/index.tsx